import React from "react";

const LoadAlert = ({ alert, onDismiss }) => {
  const alertType =
    typeof alert?.type === "string" ? alert.type.toLowerCase() : "danger"; // default to 'danger'

  return (
    <div
      className={`alert alert-${alertType} alert-dismissible fade show py-1 px-3`}
      role="alert"
    >
      <span style={{ fontSize: 10 }} className="px-2 rounded-1 bg-white">
        {alert?.shipperID
          ? "Shipper"
          : alert?.transporterID
          ? "Transporter"
          : "Both"}
      </span>
      <div dangerouslySetInnerHTML={{ __html: alert?.message || "" }} />
      <button
        onClick={() => onDismiss()}
        type="button"
        className="btn-close shadow-none"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
    </div>
  );
};

export default LoadAlert;
